import { useContext } from "react";
import { ModalSettingContext } from "../../../../index";
import s from './index.module.css';
import { TextareaWhite } from "@UI/New/InputWhite";

export const Comments = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);

    return (
        <div className={s.wrapper}>
            <TextareaWhite 
                className={s.textarea}
                placeholder='Комментарий (для сотрудников)'
                value={state.comment}
                onChange={value => setFieldInState({field: 'comment', value})}
            />
            <TextareaWhite 
                className={s.textarea}
                placeholder='Комментарий (для учащихся)'
                value={state.comment_dz}
                onChange={value => setFieldInState({field: 'comment_dz', value})}
            />
        </div>
    )
}
